import { Component, OnInit } from '@angular/core';
import { HeaderService, AuthService, MainSidebarService, UserService, NavigationService } from '@base/shared/services';
import { get, forEach, delay } from 'lodash';
import * as sideMenuItems from './side-menu-items.json';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';

@Component({
  selector: 'eyrus-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.sass']
})
export class EyrusSideMenuComponent implements OnInit {

  menuItems: Array<any> = [];
  currentUser: any = {};

  apexUrl: String = environment.apexUrl;
  accountId: any = '';

  constructor(
    private headerService: HeaderService,
    private mainSidebarService: MainSidebarService,
    private authService: AuthService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private accountService: UserService,
    private navigationService: NavigationService
  ) { }


  ngOnInit() {

    this.accountId = get(this.authService, 'accountId');
    this.menuItems = sideMenuItems['default'];
    // this.headerService.panelOpen.subscribe(() => {
    //   this.currentUser = get(this.authService, 'user') || {};
    // });
    this.currentUser = get(this.authService, 'user') || {};

    const size = window.innerWidth;
    if (size >= 700 && size <= 950) {
      setTimeout(() => {
        this.toggleSidebarCollapsed();
      }, 10);
    }
  }

  /**
   * Close side menu
   */
  close() {
    this.headerService.closeSidePanel();
  }

  /**
   * Sign out of app
   */
  logout() {
    this.close();
    this.authService.logout();
    this.router.navigate(['auth/login']);
  }

  toggleSidebarCollapsed() {
    this.mainSidebarService.panelCollapsed();
  }

  goToCompanyEdit() {
    this.router.navigate(['eyrus/profile/company']);
    this.close();
  }

  goToProfileEdit() {
    this.router.navigate(['eyrus/profile/edit']);
    this.close();
  }

  getActivePath(paths) {
    if (!paths || !paths.length)
      return;

    const active = this.router.url
      .split('/')
      .filter(part => paths.includes(part));

    return active.length > 0;
  }

  getApexUrl() {
    const projectId = get(this.accountService.account, 'project.projectId');
    let _url: String = environment.apexUrl;

    if (projectId)
      _url = _url.replace('{projectId}', projectId);
    else
      _url = _url.replace('project/{projectId}/home', '');


    return _url;
  }

  /**
   * Trigger menu actions when user selects
   * something from menu
   */
  doMenuAction(item: any) {


    if (item.disabled || item.childs || !item.display)
      return;

    // TODO, replace logic for native routerActiveLink;
    this.menuItems.forEach(item => item.activeLink = false);
    item.activeLink = true
    //

    switch (item.action) {
      case 'url-external':
        this.close();
        window.open(item.url, '_blank');
        this.navigationService.forceNavigate.next('projects')
        break;

      case 'url':
        this.close();
        this.router.navigateByUrl(item.url);

        if (item.url.indexOf('projects') !== -1)
          this.navigationService.forceNavigate.next('projects');
        break;

      case 'click':
        this[`${item.actionName}`]();
        break;
    }
  }

  sameId(id) {
    return id.toString() === this.accountId.toString()
  }

  switchAccount(account) {
    this.authService.switchUserAccount(account);
    this.router.navigate(['/eyrus/projects']);
    window.location.href = '/eyrus/projects';
  }
}
